<template>
  <div class="page">
    <div class="m-content">
      <p class="m-tit">{{moreTitle}}</p>
      <div class="m-html ql-editor" v-html="moreContent"></div>
      <div class="m-down-a">
        <a v-for="(item,index) in aDown" class="book-link" :href="item.url" :download="'附件'+index+1" :key="index">{{'附件'+(index+1)}}</a>
      </div>
    </div>
  </div>
</template>

<script>
  import 'quill/dist/quill.core.css'
  import 'quill/dist/quill.snow.css'
  import 'quill/dist/quill.bubble.css'
  export default {
    components: {},
    data () {
      return {
        moreTitle: '',
        moreContent: '',
        aDown:[],
      }
    },
    created () {
      this.getMore()
    },
    methods: {
      getMore(){
        this.http.getRequest({
          url:`app/userInfo/${this.$route.query.noticeId}`,
          msg:{},
          success:(res)=>{
            window.document.title = res.data.noticeTitle ? res.data.noticeTitle : '帮助详情'
            this.moreTitle = res.data.noticeTitle
            this.moreContent = res.data.noticeContent 
            this.aDown = res.data&&res.data.noticeAttachList ? res.data.noticeAttachList : []
          }
        })
      }
    },
    mounted () {

    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style ref="stylesheet/less" lang="less" scoped>
  .page{
    background: #F4F6F9;
    .m-content{
      position: absolute;
      top: 12px;
      left: 12px;
      right: 12px;
      bottom: 12px;
      margin: auto;
      overflow-y: auto;
      -webkit-overflow-scrolling: touch;
      z-index: 2;
      background: #ffffff;
      border-radius: 4px;
      .m-tit{
        padding: 10px;
        text-align: center;
        font-size: 15px;
        font-weight: bold;
      }
      .m-html{
        padding: 10px;
        /deep/b{
          font-weight: 600;
        }
        /deep/img{
          max-width: 100%;
          object-fit: contain;
        }
      }
      .ql-editor{
        height: inherit!important;
      }
      .m-down-a{
        padding: 30px 20px 80px 20px;
        .book-link{
          display: block;
          color: #2B6CF9;
          margin-bottom: 10px;
        }
      }
    }
  }
</style>

